import React from "react";

const AboutAreaSection = () => {
  return (
    <>
      <section className="space">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="image-box1">
                <img className="img1" src="/img/about.jpg" alt="image1" />
                <img className="img2" src="/img/about2.jpg" alt="image2" />
                <div className="media-box1">
                  <span className="media-info">10+ Years</span>
                  <p className="media-text">Of Excellence</p>
                </div>
                <div className="media-box2">
                  <span className="media-info">5000+</span>
                  <p className="media-text">Satisfied Guests</p>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="about-content">
                <div className="title-area">
                  <span className="sec-subtitle">
                    Welcome to City Life Vacation Homes
                  </span>
                  <h2 className="sec-title h1">
                    Your Perfect Stay, Every Time
                  </h2>
                  <p className="sec-text" style={{ textAlign: "justify" }}>
                    At <b>City Life Vacation Homes Rental LLC</b>, we offer
                    luxurious and affordable vacation homes in Dubai's prime
                    neighborhoods. Whether for business or leisure, our
                    properties combine comfort, convenience, and premium
                    amenities to make your stay memorable. Our portfolio ranges
                    from fully furnished apartments to spacious villas, all
                    meticulously maintained to ensure a home-away-from-home
                    experience with modern interiors and high-end furnishings.
                  </p>
                </div>

                <ul className="about-list1">
                  <li>Fully Furnished Apartments</li>
                  <li>Luxury Villas and Apartments</li>
                  <li>24/7 Customer Support</li>
                  <li>Airport Transfers</li>
                  <li>Housekeeping and Maintenance</li>
                  <li>Family-Friendly Accommodations</li>
                  <li>Flexible Booking Options</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutAreaSection;
